import axios from 'axios'
import * as types from "../mutation-types";

// state
export const state = {
    data: null,
    data_loaded: false,
    site_error: false
}

// getters
export const getters = {
    data: state => state.data,
    data_loaded: state => state.data_loaded,
    site_error: state => state.site_error,
}

// mutations
export const mutations = {
    [types.FETCH_REQUEST_A_SITE_IP_SUCCESS](state, {request_a_site})
    {
        state.data = request_a_site;
        state.data_loaded = true;
    },
    [types.FETCH_REQUEST_A_SITE_IP_FAILURE](state)
    {
        state.data = null;
        state.data_loaded = true;
        state.site_error = true;
    },
}

// actions
export const actions = {
    async getIp({commit})
    {
        try
        {
            state.data_loaded = false
            const {data} = await axios.post('/api/request-a-site/get-ip')
            commit(types.FETCH_REQUEST_A_SITE_IP_SUCCESS, {request_a_site: data})
        } catch (e)
        {
            commit(types.FETCH_REQUEST_A_SITE_IP_FAILURE);
        }
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/request_a_site.js